import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import RealEstateFeaturedPreview from './RealEstateFeaturedPreview';

export default function RealEstateFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={RealEstateFeaturedPreview}
        />
    );
}